import React, { useState, useEffect } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "../../mock";
import { fetchTestimonials } from "../../api";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const [items, setItems] = useState(TESTIMONIALS);
  const total = items.length;

  useEffect(() => {
    fetchTestimonials().then((d) => { if (d && d.length) setItems(d); }).catch((e) => console.error("Testimonials load failed:", e));
  }, []);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % total), 6000);
    return () => clearInterval(t);
  }, [total]);

  const active = items[idx] || items[0];

  return (
    <section className="bg-charcoal py-28 relative grain overflow-hidden">
      <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
        <div className="flex items-center justify-center gap-3 mb-8 reveal">
          <span className="gold-rule" />
          <span className="eyebrow text-gold">Client Stories</span>
        </div>
        <Quote className="mx-auto text-gold/60 mb-8" size={44} strokeWidth={1} />
        <blockquote key={active.id} className="reveal is-visible">
          <p className="font-display text-cream text-2xl lg:text-3xl font-light italic leading-relaxed">
            “{active.quote}”
          </p>
          <footer className="mt-9">
            <div className="font-serif-alt text-gold text-lg">{active.name}</div>
            <div className="eyebrow text-cream/50 mt-2">{active.treatment}</div>
          </footer>
        </blockquote>

        <div className="flex items-center justify-center gap-6 mt-12">
          <button
            onClick={() => setIdx((i) => (i - 1 + total) % total)}
            className="w-11 h-11 rounded-full border border-white/20 flex items-center justify-center text-cream/70 hover:border-gold hover:text-gold transition-colors"
            aria-label="Previous"
          >
            <ChevronLeft size={18} />
          </button>
          <div className="flex items-center gap-2">
            {items.map((t, i) => (
              <button
                key={t.id || i}
                onClick={() => setIdx(i)}
                className={`h-1.5 rounded-full transition-all duration-500 ${i === idx ? "w-8 bg-gold" : "w-1.5 bg-white/25"}`}
                aria-label={`Go to ${i + 1}`}
              />
            ))}
          </div>
          <button
            onClick={() => setIdx((i) => (i + 1) % total)}
            className="w-11 h-11 rounded-full border border-white/20 flex items-center justify-center text-cream/70 hover:border-gold hover:text-gold transition-colors"
            aria-label="Next"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
